import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1489956d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "seller"
};
const _hoisted_2 = {
  class: "workspace-content"
};
const _hoisted_3 = {
  class: "name-group"
};
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = ["id"];
const _hoisted_6 = ["id"];
const _hoisted_7 = {
  class: "alert-count"
};
const _hoisted_8 = {
  class: "alert-popover"
};
const _hoisted_9 = {
  class: "header"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Alerts", -1));
const _hoisted_11 = {
  class: "total-alert"
};
const _hoisted_12 = {
  class: "alert-details"
};
const _hoisted_13 = {
  class: "alert-icon"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Urgent", -1));
const _hoisted_15 = {
  class: "alert-count"
};
const _hoisted_16 = {
  class: "alert-details"
};
const _hoisted_17 = {
  class: "alert-icon"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Alert", -1));
const _hoisted_19 = {
  class: "alert-count"
};
const _hoisted_20 = {
  class: "alert-details"
};
const _hoisted_21 = {
  class: "alert-icon"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Warning", -1));
const _hoisted_23 = {
  class: "alert-count"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_popover = _resolveComponent("app-popover");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_loading_element = _resolveComponent("loading-element");
  const _component_b_td = _resolveComponent("b-td");
  return _openBlock(), _createBlock(_component_b_td, {
    class: _normalizeClass(["portfolio-td-workspace", {
      'border-top': !$props.portfolio.collapsed && !$props.portfolio.seller_id,
      'border-left': !$props.portfolio.collapsed,
      'border-bottom': !$props.portfolio.collapsed && $props.portfolio.seller_id && $props.isLastSellerInWorkspace,
      'border-radius-top-left': !$props.portfolio.collapsed && !$props.portfolio.seller_id,
      'border-radius-bottom-left': !$props.portfolio.collapsed && $props.portfolio.seller_id && $props.isLastSellerInWorkspace
    }]),
    "sticky-column": ""
  }, {
    default: _withCtx(() => [_createVNode(_component_loading_element, {
      loading: $props.loading
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        class: "flag",
        src: _ctx.getCountryFlag($options.getCountryCode($props.portfolio.sales_channel)),
        alt: $props.portfolio.country
      }, null, 8, _hoisted_4), _createElementVNode("div", {
        id: _ctx.buildPortfolioTargetId($props.portfolio, 'name'),
        class: "workspace-name",
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => $options.onSellerNameClickHandler($props.portfolio.workspace_id, $props.portfolio.seller_id), ["stop"]))
      }, _toDisplayString($props.portfolio.seller_name ?? "-"), 9, _hoisted_5), _createVNode(_component_app_popover, {
        target: _ctx.buildPortfolioTargetId($props.portfolio, 'name'),
        placement: "top"
      }, {
        default: _withCtx(() => [_createTextVNode(" Open Workspace ")]),
        _: 1
      }, 8, ["target"])]), _createElementVNode("div", {
        class: "workspace-alert",
        id: _ctx.buildPortfolioTargetId($props.portfolio, 'alert'),
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => _ctx.onSellerAlertClickHandler($props.portfolio.workspace_id, $props.portfolio.seller_id), ["stop"]))
      }, [_createVNode(_component_app_icon, {
        icon: "brand-portfolio-alert"
      }), _createElementVNode("span", _hoisted_7, _toDisplayString($options.formatAlertCount($props.portfolio.total_alert_count ?? 0)), 1), _createVNode(_component_app_popover, {
        target: _ctx.buildPortfolioTargetId($props.portfolio, 'alert'),
        placement: "top",
        customClass: "brand-portfolio"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, _toDisplayString($options.formatAlertCount($props.portfolio.total_alert_count ?? 0)) + " Total ", 1)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_app_icon, {
          icon: "alert",
          color: "#DB333B"
        }), _hoisted_14]), _createElementVNode("span", _hoisted_15, _toDisplayString($options.formatAlertCount($props.portfolio.alert_count_level_1 ?? 0)), 1)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_app_icon, {
          icon: "alert",
          color: "#FF8933"
        }), _hoisted_18]), _createElementVNode("span", _hoisted_19, _toDisplayString($options.formatAlertCount($props.portfolio.alert_count_level_2 ?? 0)), 1)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createVNode(_component_app_icon, {
          icon: "alert",
          color: "#F0C329"
        }), _hoisted_22]), _createElementVNode("span", _hoisted_23, _toDisplayString($options.formatAlertCount($props.portfolio.alert_count_level_3 ?? 0)), 1)])])]),
        _: 1
      }, 8, ["target"])], 8, _hoisted_6)])])]),
      _: 1
    }, 8, ["loading"])]),
    _: 1
  }, 8, ["class"]);
}